import z from 'zod'

import { filtersSchema } from '@/shared/components/filter/validation'
import { ExportGroupBy, ExportType } from '@/shared/generated'

export const createExportSchema = z.object({
	require_callback: z.boolean(),
	name: z.string().min(1, 'Name is required'),
	type: z.enum(Object.values(ExportType)),
	filters: filtersSchema,
	group_by: z.enum(Object.values(ExportGroupBy)).nullable(),
	columns: z.array(
		z.object({
			name: z.string().min(1, 'Name is required'),
			header: z.string().min(1, 'Header is required'),
			static_value: z.string().nullable(),
			reference: z
				.object({
					entity: z.string().min(1, 'Entity is required'),
					field: z.string().min(1, 'Field is required'),
				})
				.nullable(),
		})
	),
})
